(function () {
  function initBundleFooter(section) {
    const button = section.querySelector('.et-bundle-footer__scroll-top');
    if (!button || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';

    const threshold = Number(button.dataset.scrollThreshold || section.style.getPropertyValue('--et-bundle-footer-scroll-threshold') || 100);

    function updateVisibility() {
      if (window.scrollY <= threshold) {
        button.classList.remove('is-visible');
      } else {
        button.classList.add('is-visible');
      }
    }

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  }

  function initAll() {
    document.querySelectorAll('.et-bundle-footer').forEach(initBundleFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.et-bundle-footer');
    if (section) initBundleFooter(section);
  });
})();
